<template>
  <div id="dashboard-patrol">
    <!-- Table Container Card -->
    <b-card
      no-body
    >
      <div class="m-2">
        <h5 class="pb-50 mb-2">
          Guards Patrol Monitoring
        </h5>
        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Entries</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button
              v-if="$can('view', 'dashboardFullView')"
              variant="primary"
              :to="{ name: 'dashboard-full-view'}"
              class="mr-2"
            >
              <span class="text-nowrap">Dashboard Full View</span>
            </b-button>
            <div>
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refDashboardListTable"
        :items="dataDashboard"
        :filter="searchQuery"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        striped
      >
        <template #cell(actions)="data">
          <b-button
            variant="primary"
            @click="viewData(data.item.id, data.item.area_id)"
          >
            <span class="text-nowrap">View</span>
          </b-button>
          <b-button
            v-if="data.item.status==0"
            variant="primary ml-1"
            @click="cancelData(data.item.id)"
          >
            <span class="text-nowrap">Cancel</span>
          </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalDashboard"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <dashboard-progress-circle v-if="isProgressDataFetched" :data="progressData" />
    <!-- <dashboard-patrol-history :data="fetchPatrolHistory" /> -->
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  onUnmounted, ref, watch, computed,
} from '@vue/composition-api'
import store from '@/store'
// import useDashboardList from '@/views/dashboard/useDashboardList'
import dashboardStoreModule from '@/views/dashboard/dashboardStoreModule'
import dashboardProgressCircle from '@/views/dashboard/dashboardProgressCircle.vue'
// import dashboardPatrolHistory from '@/views/dashboard/dashboardPatrolHistory.vue'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BButton,
    dashboardProgressCircle,
    // dashboardPatrolHistory,

    vSelect,
  },
  data() {
    return {
      progressData:{},
      isProgressDataFetched: false,
      interval: null,
    }
  },
  methods: {
    patrolHistoryTypeConvert(value){
      console.log(value)
      if (value !== null){
        if (value.type == 0){
          return '(Dimulai Patrol)' 
        } else if (value.type == 4){
          return '(Berakhir Patrol)'
        } else {
          return `${value.location_name} - (Sedang Berlangsung Patrol)`
        }
      }
    },
    viewData(idValue, areaIdValue){
      store
        .dispatch('app-dashboard/fetchDashboardDetail', {
          id: idValue,
          area_id: areaIdValue,
        })
        .then(response => {
          console.log('ini api detail dashboard')
          console.log(response)
          this.progressData = response.data.data
          this.isProgressDataFetched = true
        })
        .catch(() => {
          this.isProgressDataFetched = false
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching dasboard detail ",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    cancelData(idValue){
      store
        .dispatch('app-dashboard/cancelDashboard', {
          id: idValue,
        })
        .then(response => {
          console.log('ini api cancel dashboard')
          console.log(response)
          location.reload();
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Error cancel an on-going patrol",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  mounted(){
    this.fetchDashboards()
    let self = this
    this.interval = setInterval(function() {
      self.fetchDashboards()
      // self.viewData()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-dashboard'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, dashboardStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    // Table Handlers
    const tableColumns = [
      { key: 'area_name', label: 'site', sortable: true },
      { key: 'guard_name', label: 'on_patrol', sortable: true },
      { 
        key: 'last_state', 
        label: 'checkpoint', 
        sortable: true, 
        formatter: 'patrolHistoryTypeConvert',
        filterByFormatted: true,
      },
      { key: 'patrol_date', label: 'time', sortable: true },
      { key: 'actions' },
    ]

    // Use toast
    const toast = useToast()

    const refDashboardListTable = ref(null)
    const dataDashboard = ref(null)

    const perPage = ref(10)
    const totalDashboard = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
      const localItemsCount = refDashboardListTable.value ? refDashboardListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalDashboard.value,
      }
    })

    const refetchData = () => {
      refDashboardListTable.value.refresh()
    }

    watch([currentPage, perPage], () => {
      fetchDashboards()
      refetchData()
    })

    const fetchDashboards = (ctx, callback) => {
      store
        .dispatch('app-dashboard/fetchDashboardList', {
          // q: searchQuery.value,
          perPage: perPage.value,
          currentPage: currentPage.value,
          // sortBy: sortBy.value,
          // sortDesc: isSortDirDesc.value,
          // status: statusFilter.value,
        })
        .then(response => {
          console.log('ini api')
          console.log(response)
          // const data = response.data.data.list
          // callback(data)
          dataDashboard.value = response.data.data.list
          totalDashboard.value = response.data.data.total
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Error fetching Dashboard list",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
      tableColumns,
      perPage,
      currentPage,
      totalDashboard,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDashboardListTable,
      dataDashboard,
      toast,

      refetchData,
      fetchDashboards,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
